export const tnds2025Photos = [
  "_CP30362.jpg",
  "_CP14854.jpg",
  "_CP31499.jpg",
  "_TP11651.jpg",
  "CP200292.jpg",
  "_TP11707.jpg",
  "CP200744.jpg",
  "CP205298.JPG",
  "TP109047.jpg",
  "TP109909.jpg",
  "TP109940.jpg",
  "TP200647.jpg",
  "TP200757.jpg",
  "TP200902.jpg",
  "TP201114.png",
  "TP201375.png",
  "TP201460.jpg",
  "TP201500.jpg",
  "TP201504.jpg",
  "TP201517.jpg",
  "TP201565.jpg",
  "TP201693.jpg",
  "TP201732.jpg",
  "TP201755.jpg",
  "TP201765.jpg",
  "TP201805.jpg",
  "TP201820.jpg",
  "TP201859.jpg",
  "TP201869.jpg",
  "TP201892.jpg",
  "TP202176.jpg",
  "TP202204.jpg",
  "TP202464.jpg",
  "TP202564.jpg",
  "TP202594.jpg",
  "TP202674.jpg",
  "TP202714.jpg",
  "TP202726.jpg",
  "TP202979.jpg",
  "TP203180.jpg",
  "TP203217.jpg",
  "TP203226.jpg",
  "TP203270.jpg",
  "TP203340.jpg",
  "TP203356.jpg",
  "TP203434.jpg",
  "TP203475.jpg",
  "TP203539.jpg",
  "TP203761.jpg",
  "TP203846.jpg",
];
